module.exports = __webpack_public_path__ + "static/media/McGee.3341411f.png";